// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__TsY2I","paramInput":"JobSimulator_paramInput__1VNVd","input":"JobSimulator_input__2-vqW"};